var $c99d1f332dc5c52f$exports = {};
$c99d1f332dc5c52f$exports = {
    "maximum": `\u{39C}\u{3AD}\u{3B3}\u{3B9}\u{3C3}\u{3C4}\u{3BF}`,
    "minimum": `\u{395}\u{3BB}\u{3AC}\u{3C7}\u{3B9}\u{3C3}\u{3C4}\u{3BF}`
};


export {$c99d1f332dc5c52f$exports as default};
//# sourceMappingURL=el-GR.module.js.map
